import React, { useCallback, useEffect, useState } from 'react'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { CircularProgress, useTheme, Tooltip } from '@material-ui/core'

import { Page, Header, CustomTable } from 'components'
import { useCasoService } from 'hooks/useCasoService'
import useRouter from 'utils/useRouter'
import { useStyles } from './CasosDoSetor.styles'

export const CasosDoSetor = (props) => {
  const { route } = props
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const theme = useTheme()
  const router = useRouter()
  const casoService = useCasoService()

  const [casos, setCasos] = useState([])
  const [processando, setProcessando] = useState(true)

  const buscarCasosDoSetor = useCallback(async () => {
    setProcessando(true)
    try {
      const dados = await casoService.listarCasosDoSetorAsync()
      setCasos(dados || [])
    } catch (error) {
      console.error('Erro ao buscar casos do setor:', error)
    } finally {
      setProcessando(false)
    }
  }, [])

  useEffect(() => {
    buscarCasosDoSetor()
  }, [buscarCasosDoSetor])

  const handleRowClick = (id) => {
    router.history.push(`/casos/caso/detalhar/${id}`)
  }

  const colunas = [
    {
      title: 'Identificador',
      field: 'identificador',
      cellStyle: { fontWeight: 600, width: '15%', minWidth: '120px' },
    },
    {
      title: 'Descrição',
      field: 'descricao',
      cellStyle: { minWidth: '250px' },
      render: (rowData) => (
        <Tooltip title={rowData.descricao || 'Sem descrição'} arrow placement="top-start">
          <div
            style={{
              maxWidth: '380px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: theme.palette.text.secondary,
            }}
          >
            {rowData.descricao || 'Sem descrição registrada'}
          </div>
        </Tooltip>
      ),
    },
    {
      title: 'Órgão responsável',
      field: 'setRes.nome',
      render: (rowData) => rowData.setRes?.nome?.toUpperCase() || '-',
      cellStyle: { minWidth: '180px' },
    },
    {
      title: 'Data',
      field: 'data',
      type: 'date',
      defaultSort: 'desc',
      render: (rowData) => moment(rowData.data || rowData.createdAt).format('DD/MM/YYYY HH:mm'),
      cellStyle: { width: '15%', minWidth: '160px' },
    },
  ]

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={`${route.secao} cadastrados`} overline={route.secao} />

      {processando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <CustomTable columns={colunas} data={casos} onRowClick={(event, rowData) => handleRowClick(rowData.id)} searchPlaceholder="Buscar casos..." emptyDataSourceMessage="Nenhum caso encontrado" />
      )}
    </Page>
  )
}
